import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for AuthStore, for use in the registry */ export const AuthStoreActionTypes = [
    ActionType.ClearAccessTokenAction,
    ActionType.FetchAccessTokenAction,
    ActionType.FetchAccessTokenSucceededAction,
    ActionType.FetchAccessTokenFailedAction
];
